import React from 'react'
import Grid from '@material-ui/core/Grid'
import { StyledButton, StyledParagraph } from '../../../theme/Global'
import { CustomH1, CustomH2, CustomH5, CustomLine } from './styles'
import OffsiteContentComponent from '../../../common/components/offSiteContent'
import APILoadingSpinnerRenderer from '../../../app/components/apiLoadingSpinner'
import { downloadMinimumWageUserGuide } from '../../../static-files/static-pdf-service'
import { CustomLineWithMargin } from '../../../compliance/components/help/styles'
import AccountContact from '../../../common/components/AccountContact/AccountContact'

const withoutPaper = true

const MinimumWageHelpRenderer = ({ isLoading }) => (
  <Grid container>
    <Grid item xs={12}>
      <CustomH1>Help</CustomH1>
      <CustomLine />
    </Grid>
    <Grid item xs={7}>
      <CustomH5>User Guide Download</CustomH5>
      <StyledParagraph>Download the user guide for more information.</StyledParagraph>
      <StyledButton onClick={downloadMinimumWageUserGuide}>Download Now</StyledButton>
    </Grid>
    {isLoading ? (<APILoadingSpinnerRenderer withoutPaper={withoutPaper} />) : (
      <React.Fragment>
        <Grid container item xs={5}>
          <AccountContact type="minWagePaidLeave" />
        </Grid>
        <Grid item xs={12}>
          <CustomLineWithMargin />
        </Grid>
        <Grid item xs={12}>
          <CustomH2>FAQs</CustomH2>
          <OffsiteContentComponent contentKey="minimum-wage-FAQ" />
        </Grid>
      </React.Fragment>
    )}
  </Grid>
)

export default MinimumWageHelpRenderer
